import {forwardRef, useMemo} from 'react';
import {
	Droppable,
	DroppableProps,
	DroppableProvided,
	DroppableStateSnapshot,
} from 'react-beautiful-dnd';
import {OsChecker} from '../../utils';

export const DroppableContainer = forwardRef<Droppable, Omit<DroppableProps, 'children'> & {className?: string, children?: any, cursor?: string}>((props, ref) => {
	const styles = useMemo(() => {
		return {
			cursor: OsChecker.isMac() && 'grabbing' || 'move', //snapshot.isDraggingOver ? this.props.cursor || 'grab' : 'auto'
		};
	}, []);

	function renderInner({provided, snapshot}: {provided: DroppableProvided; snapshot: DroppableStateSnapshot}) {
		const children = props.children as any;
		if (typeof children === 'function') {
			return children(provided, snapshot);
		} else {
			return <div
				{...provided.droppableProps}
				ref={provided.innerRef}
				style={styles}
				className={props.className || ''}
			>
				{props.children}
				{provided.placeholder}
			</div>;
		}
	}


	return <Droppable droppableId={props.droppableId} type={props.type}
	                  direction={props.direction}
	                  ignoreContainerClipping={props.ignoreContainerClipping}
	                  isCombineEnabled={props.isCombineEnabled}
	                  isDropDisabled={props.isDropDisabled}
	                  mode={props.mode}
	                  renderClone={props.renderClone}>
		{(provided, snapshot) => renderInner({provided: provided, snapshot: snapshot})}
	</Droppable>;
});
